export default "__VITE_ASSET__Pgl$5sVNiyRw7t7RzmKrwA__"